import {
  REPORT_FILE_ADMIN_GET_GROUPS_INIT,
  REPORT_FILE_ADMIN_GET_GROUPS_SUCCESS,
  REPORT_FILE_ADMIN_GET_GROUPS_FAILURE,
  REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_INIT,
  REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_SUCCESS,
  REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_FAILURE,
  REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_INIT,
  REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_SUCCESS,
  REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_FAILURE,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_INIT,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_SUCCESS,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_FAILURE,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_INIT,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SUCCESS,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_FAILURE,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_INIT,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_SUCCESS,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_FAILURE,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_INIT,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_SUCCESS,
  REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_FAILURE,
  REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_INIT,
  REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_SUCCESS,
  REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_FAILURE,
  REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_INIT,
  REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_SUCCESS,
  REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_FAILURE,
  REPORT_FILE_ADMIN_DELETE_REPORT_FILE_PREPARE_INIT,
  REPORT_FILE_ADMIN_DELETE_REPORT_FILE_INIT,
  REPORT_FILE_ADMIN_DELETE_REPORT_FILE_SUCCESS,
  REPORT_FILE_ADMIN_DELETE_REPORT_FILE_FAILURE,
  REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_INIT,
  REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_SUCCESS,
  REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_FAILURE,
  REPORT_FILE_ADMIN_RESET
} from './types';
import ActionsTooling from '../../../tooling/actionsTooling';
import Constants from '../../../definitions/constants';
import FilesTooling from '../../../tooling/filesTooling';
import { intl } from '../../../locales/localesConfig';

export function reset() {
  return {
    type: REPORT_FILE_ADMIN_RESET
  };
}

export function getGroupsList(periodId) {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: [],
    searches_are: [],
    active: true,
    period_id: periodId,
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: REPORT_FILE_ADMIN_GET_GROUPS_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/group/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(REPORT_FILE_ADMIN_GET_GROUPS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(REPORT_FILE_ADMIN_GET_GROUPS_FAILURE, error));
    }  
  };
}

export function getCalculationUnitsList(keyword, groupId, periodId) {
  let params = {
    mini_list_version: true, 
    order_fields: ["last_names", "first_names"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC, Constants.crudGenerator.orderTypes.ASC],
    fields_like: [["last_names", "first_names", "code"]],
    searches_like: [keyword, keyword, keyword],
    fields_are: [],
    searches_are: [],
    active: true,
    period_id: periodId,
    per_page: Constants.interface.fullListPageSize,
    group_id: groupId
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationunit/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_FAILURE, error));
    }  
  };
}

export function getCalculationUnitsEmailSearchList(keyword, periodId) {
  let params = {
    mini_list_version: true, 
    order_fields: ["last_names", "first_names"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC, Constants.crudGenerator.orderTypes.ASC],
    fields_like: [["last_names", "first_names", "code"]],
    searches_like: [keyword, keyword, keyword],
    fields_are: [],
    searches_are: [],
    active: true,
    period_id: periodId,
    per_page: Constants.interface.fullListPageSize,
    group_id: "",
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationunit/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_FAILURE, error));
    }  
  };
}

export function getCalculationUnitsEmailSearchQueryList(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        '/api/reportfile/getcalculationunitsemailquery',
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SEARCH_QUERY_FAILURE, error));
    }  
  };
}

export function getCalculationUnitsEmailList(keyword, groupId, periodId) {
  let params = {
    mini_list_version: true, 
    order_fields: ["last_names", "first_names"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC, Constants.crudGenerator.orderTypes.ASC],
    fields_like: [["last_names", "first_names", "code"]],
    searches_like: [keyword, keyword, keyword],
    fields_are: [],
    searches_are: [],
    active: true,
    period_id: periodId,
    per_page: Constants.interface.fullListPageSize,
    group_id: groupId
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationunit/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(REPORT_FILE_ADMIN_GET_CALCULATION_UNITS_EMAIL_FAILURE, error));
    }  
  };
}

export function generateReportFiles(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/reportfile/generatereportfiles",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(REPORT_FILE_ADMIN_GENERATE_REPORT_FILES_FAILURE, error));
    }  
  };
}

export function getReportFilesHistory(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/reportfile/reportfileshistory",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(REPORT_FILE_ADMIN_GET_REPORT_FILES_HISTORY_FAILURE, error));
    }  
  };
}

export function getEmailHistory(params, paging = true) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/reportfile/emailhistory",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(REPORT_FILE_ADMIN_GET_EMAIL_HISTORY_FAILURE, error));
    }  
  };
}

export function sendReportFileToEmails(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/reportfile/sendReportFileToEmails",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(REPORT_FILE_ADMIN_SEND_REPORT_FILE_TO_EMAIL_FAILURE, error));
    }  
  };
}
	
export function prepareDeleteReportFile(id) {
  return {
    type: REPORT_FILE_ADMIN_DELETE_REPORT_FILE_PREPARE_INIT,
    id: id
  };
}

export function deleteReportFile(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(REPORT_FILE_ADMIN_DELETE_REPORT_FILE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/reportfile/delete",
        "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(REPORT_FILE_ADMIN_DELETE_REPORT_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(REPORT_FILE_ADMIN_DELETE_REPORT_FILE_FAILURE, error));
    }  
  };
}

export function downloadReportFile(params, report) {
  let isPdf = report.is_pdf;
  let fileName = isPdf ? report.download_url.replace("job_" + report.job_key + "_", "") : intl.formatMessage({id: "reportFileAdmin.downloadFileName"});
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_INIT));
    try {
      const resp = await FilesTooling.downloadFileClientSide(
        "/api/reportfile/downloadreportfile",
        fileName,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(REPORT_FILE_ADMIN_DOWNLOAD_REPORT_FILE_FAILURE, error));
    }  
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/reportFileAdmin/index.js